export default __webpack_public_path__ + "static/media/savinski.4111bf1a.png";